import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxProfessionalServices.css';

const RedboxProfessionalServices = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Professional Services - Expert Financial Solutions | Redbox Global</title>
        <meta name="description" content="Discover Redbox Professional Services offering expert consulting, data analytics, workflow optimization, and custom solutions for financial institutions and investment firms worldwide." />
        <meta name="keywords" content="professional services, financial consulting, data analytics, workflow optimization, market intelligence, Bloomberg Professional Services, financial advisory, enterprise solutions, consulting services" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/professional-services" />
        <meta property="og:title" content="Redbox Professional Services - Expert Financial Solutions" />
        <meta property="og:description" content="Transform your business with Redbox Professional Services. Expert consulting, analytics, and custom solutions for the financial industry." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/professional-services" />
        <meta name="twitter:title" content="Redbox Professional Services - Expert Financial Solutions" />
        <meta name="twitter:description" content="Expert consulting and custom solutions for financial institutions." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/professional-services" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "Redbox Professional Services",
            "description": "Expert consulting and custom solutions for financial institutions worldwide.",
            "url": "https://redboxglobal.com/professional-services",
            "provider": {
              "@type": "Organization",
              "name": "Redbox Global",
              "logo": {
                "@type": "ImageObject",
                "url": "https://redboxglobal.com/logo.png"
              }
            },
            "serviceType": "Financial Consulting and Data Analytics"
          })}
        </script>
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Redbox Professional Services</h1>
        <p className="page-subtitle">Expert consulting and tailored solutions for financial excellence</p>
      </div>
      
      <div className="page-content">
        <a href="/article/professional-services-overview" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=600&fit=crop" alt="Professional consulting services" />
            </div>
            <div className="featured-content">
              {/* <span className="article-category">Our Expertise</span> */}
              <h2>Transform Your Business with Expert Consulting</h2>
              <p>Redbox Professional Services delivers world-class consulting and custom solutions to financial institutions, investment firms, and corporations. Our team of experts provides strategic advisory, data analytics, workflow optimization, and implementation services that drive measurable results and competitive advantage in today's dynamic markets.</p>
              <span className="article-meta">Learn More</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/data-analytics-consulting" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop" alt="Data analytics dashboard" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Analytics</span> */}
                <h2>Advanced Data Analytics & Intelligence Solutions</h2>
                <p>Unlock the power of your data with our advanced analytics services. From predictive modeling to real-time market intelligence dashboards.</p>
                <span className="article-meta">Explore Services</span>
              </div>
            </article>
          </a>

          <a href="/article/workflow-optimization" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop" alt="Workflow optimization" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Efficiency</span> */}
                <h2>Workflow Optimization & Process Automation</h2>
                <p>Streamline operations and reduce costs with our workflow consulting. We help automate processes and integrate systems for maximum efficiency.</p>
                <span className="article-meta">Get Started</span>
              </div>
            </article>
          </a>

          <a href="/article/enterprise-implementation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop" alt="Enterprise implementation" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Implementation</span> */}
                <h2>Enterprise Solutions & Custom Development</h2>
                <p>Tailored solutions designed for your unique business needs. From system integration to custom application development and deployment.</p>
                <span className="article-meta">Contact Us</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default RedboxProfessionalServices;
